import { useTranslation } from "react-i18next";

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full bg-background-50 py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        {/* Image container */}
        <div className="relative rounded-3xl overflow-hidden mb-12 mx-auto max-w-3xl">
          <img
            src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20of%20beautifully%20arranged%20fashion%20accessories%20and%20leather%20goods%20on%20cream%20marble%20surface%2C%20warm%20candlelight%20ambiance%2C%20luxury%20lifestyle%20aesthetic%2C%20soft%20shadows%2C%20editorial%20style%2C%20clean%20composition%2C%20no%20text%20no%20logos%2C%20sophisticated%20commercial%20photography&width=1600&height=900&seq=cta-cssbuy-v2&orientation=landscape"
            alt="CSSBuy Spreadsheet links collection"
            className="w-full h-auto object-cover"
            loading="lazy"
          />
        </div>

        {/* CTA Content */}
        <div className="text-center">
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 mb-4 leading-tight">
            {t("cta.title")}
          </h2>
          <p className="text-lg text-foreground-500 mb-8">
            {t("cta.subtitle")}
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-10 py-4 bg-foreground-950 text-background-50 rounded-full font-medium text-sm hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            {t("cta.button")}
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}